import { setAppElement } from "react-modal";
var reactModalInitialized = false;
/**
 * Calls ReactModal.setAppElement which is required before showing any ReactModal dialog.
 * This function can be safely called many times.
 * It should not be called until we actually try to show a modal, in order to defer loading
 * all the react-modal JS.
 */ export var initializeReactModal = function() {
    if ("production" !== "test" && !reactModalInitialized) {
        setAppElement("#root");
        reactModalInitialized = true;
    }
};
